import { gql } from 'glimmer-apollo';

// Common fragments for reuse across queries

export const AUTHOR_INFO_FRAGMENT = gql`
  fragment AuthorInfo on Author {
    name
    avatar {
      url(
        width: 48
        height: 48
        fit: cover
        format: webp
      )
    }
  }
`;

export const COVER_IMAGE_FRAGMENT = gql`
  fragment CoverImageInfo on Asset {
    url(
      transform: { width: 300, height: 180, resizeStrategy: FILL, format: WEBP }
    )
  }
`;

export const COVER_IMAGE_LARGE_FRAGMENT = gql`
  fragment CoverImageLargeInfo on Asset {
    url(
      transform: { width: 800, height: 450, resizeStrategy: FILL, format: WEBP }
    )
  }
`;

// Article type specific fragments since they're different GraphQL types
export const GAME_ARTICLE_FRAGMENT = gql`
  fragment GameArticleInfo on GameArticle {
    __typename
    title
    slug
    shortDescription
    publishedDate
    coverImage {
      url
    }
    author {
      name
      avatar {
        url
      }
    }
  }
`;

export const ESPORTS_ARTICLE_FRAGMENT = gql`
  fragment ESportsArticleInfo on ESportsArticle {
    __typename
    title
    slug
    shortDescription
    publishedDate
    coverImage {
      url
    }
    author {
      name
      avatar {
        url
      }
    }
  }
`;

export const REVIEW_ARTICLE_FRAGMENT = gql`
  fragment ReviewArticleInfo on ReviewArticle {
    __typename
    title
    slug
    shortDescription
    publishedDate
    coverImage {
      url
    }
    author {
      name
      avatar {
        url
      }
    }
  }
`;

export const GAME_INFO_FRAGMENT = gql`
  fragment GameInfo on Game {
    title
    slug
    description
    coverImage {
      url(
        transform: {
          width: 200
          height: 200
          resizeStrategy: FILL
          format: WEBP
        }
      )
    }
    genre
    platform
  }
`;

export const STREAMER_INFO_FRAGMENT = gql`
  fragment StreamerInfo on Streamer {
    displayName
    slug
    bio
    profilePicture {
      url(
        transform: {
          width: 96
          height: 96
          resizeStrategy: THUMB
          format: WEBP
        }
      )
    }
    isLive
    followerCount
  }
`;

export const TOURNAMENT_INFO_FRAGMENT = gql`
  fragment TournamentInfo on Tournament {
    title
    slug
    description
    startDate
    endDate
    prizePool
    status
    game {
      ...GameInfo
    }
  }
`;

export const TEAM_INFO_FRAGMENT = gql`
  fragment TeamInfo on Team {
    name
    slug
    logo {
      url(
        transform: {
          width: 64
          height: 64
          resizeStrategy: THUMB
          format: WEBP
        }
      )
    }
    region
    ranking
  }
`;

export const PLAYER_INFO_FRAGMENT = gql`
  fragment PlayerInfo on Player {
    displayName
    slug
    realName
    profilePicture {
      url(
        transform: {
          width: 64
          height: 64
          resizeStrategy: THUMB
          format: WEBP
        }
      )
    }
    team {
      ...TeamInfo
    }
    role
  }
`;
